import { render, staticRenderFns } from "./metrica.vue?vue&type=template&id=06b7a340&scoped=true"
import script from "./metrica.vue?vue&type=script&lang=js"
export * from "./metrica.vue?vue&type=script&lang=js"
import style0 from "./metrica.vue?vue&type=style&index=0&id=06b7a340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7a340",
  null
  
)

export default component.exports